import { useEffect, useState } from "react";
import { Box, CircularProgress } from "@mui/material";
import SignIn from "./SignIn";
import { useAuthContext } from "../context/authContext";
import authApi from "../api/authApi";

const ProtectedRoute = ({ element }) => {
  const { user, saveUser } = useAuthContext();
  const [isLoading, setIsLoading] = useState(!user);

  useEffect(() => {
    if (user) return;

    const fetchUser = async () => {
      try {
        const { data } = await authApi.get(`/auth/current`);
        saveUser(data.user);
      } catch {
        // not authenticated — SignIn will be shown
      } finally {
        setIsLoading(false);
      }
    };

    fetchUser();
  }, [user, saveUser]);

  if (isLoading) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
        <CircularProgress />
      </Box>
    );
  }

  return user ? element : <SignIn />;
};

export default ProtectedRoute;
